////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { isNull, isUndefined } from 'lodash'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
///////COMPONENTS///////
import ArticleDatePicker from '../ArticleDatePicker'
import { articleLifeManagerActionCreators } from '../../../../../store/actions'

/////////STYLED/////////
const EditStopWithRestockWrapper = styled.div``
/////////STYLED/////////
//[88]_f: MODIFY DATE STOP RESTOCK
const EditStopWithRestock = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateToModify, setDateToModify] = useState('')

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		let testDateToModify = !isNull(dateToModify) || !isUndefined(dateToModify) ? dateToModify.toString().split(' ').splice(0, 4) : null
		let testCurrentDate = moment().toDate().toString().split(' ').splice(0, 4)
		if (testDateToModify.join('') === testCurrentDate.join('')) {
			actionsArticleLifeManager.postEditStopWithRestock(match.params.id, 'editStopWithRestockAction', moment().add(5, 'minutes').toDate())
		} else {
			actionsArticleLifeManager.postEditStopWithRestock(match.params.id, 'editStopWithRestockAction', dateToModify)
		}
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (props.editStopWithRestockAction.show) {
			if (isNull(props.editStopWithRestockAction?.item?.dateLimit)) {
				handleChangeDate(new Date())
			} else {
				setDateToModify(props.editStopWithRestockAction?.item?.dateLimit)
				handleChangeDate(new Date(props.editStopWithRestockAction?.item?.dateLimit))
			}
		}
	}, [props.editStopWithRestockAction.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.editStopWithRestockAction.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<EditStopWithRestockWrapper>
			<ArticleDatePicker
				showModal={props.editStopWithRestockAction.show}
				date={dateToModify}
				handleValidate={handleValidate}
				handleClose={props.editStopWithRestockAction.close}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_restock_startDate_edit_title']}
				priorLimit={new Date(props.editStopWithRestockAction?.item?.dateScheduledDeactivation)}
			/>
		</EditStopWithRestockWrapper>
	)
}

EditStopWithRestock.propTypes = {}

EditStopWithRestock.defaultPropTypes = {}

export default EditStopWithRestock
